import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'label[iu-apiz-label]',
  standalone: true,
  imports: [],
  host: {
    '[title]': 'label()',
    '[attr.for]': 'uuid',
    '[style.fontSize]': 'fontSize()',
    '[class.iu-field-only-label]': 'isFieldOnly()',
  },
  templateUrl: './label-ui.component.html',
  styleUrl: './label-ui.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelUiComponent {
  readonly label = input.required<string>();
  readonly for = input.required<string>();
  readonly fontSize = input.required<string>();
  readonly isFieldOnly = input.required<boolean>();
}
